import {tagColors} from "@/components/tag/tag-colors";

export const WarehouseEum = {
  type: {
    FBA: 'FBA',
    SELF: 'SELF'
  },
  typeOption: [
    {id: 'SELF', text: '自营'},
    {id: 'FBA', text: 'FBA'},
  ],
  state: {
    Active: 'Active',
    Inactive: 'Inactive'
  },
  stateOption: [
    {id: 'Active', text: '启用',...tagColors.greenText},
    {id: 'Inactive', text: '停用',...tagColors.gray9Text},
  ],
  countryOption: [
    {id: 'CN', text: 'CN'}
  ]
};
